import { Injectable } from '@angular/core';
import { ColumnChartModel } from './ticketing-charts/column-chart/column-chart.model';
import { ChartList } from './ticketing-charts/pie-chart/chartlist.model';
import { SankeyModel } from './ticketing-charts/sankey-chart/sankey.model';
import { TicketsService } from '@shared/services/ticketing.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@shared/services/auth.service';
import { DataStoreService } from '@shared/services/dataStore.service';
import { ApiService } from '@shared/services/api.service';
import ticketChartAPIConfig from 'src/app/modules/charts/ticketing-charts-api.config.json';

@Injectable()
export class TicketingChartsService {
  ticketingConstants: any;
  assignmentGroups: any;
  loggedInUserSysId: any;

  constructor(
    private ticketingService: TicketsService,
    private translateService: TranslateService,
    private apiService: ApiService,
    private authService: AuthService,
    private dataStore: DataStoreService
  ) {
    // this.getAssignmentGroups();
  }

  // getAssignmentGroups() {
  //   this.authService.getUserSysId().then((userSysID: any) => {
  //     this.loggedInUserSysId = userSysID;
  //     this.getAssignmentGroupForUser(userSysID).subscribe(
  //       assignmentGroups => {
  //         this.assignmentGroups = assignmentGroups;
  //       },
  //       error => {
  //         this.assignmentGroups = null;
  //       }
  //     );
  //   });
  // }

  // getAssignmentGroupForUser(user_sys_id: string) {
  //   return this.apiService.post(ticketAPIConfig.getGroupsBasedOnUser, {
  //     id: user_sys_id
  //   });
  // }

  ticketsResolvedbyKOvsManual(tickets: any) {
    const output: any = {};
    const kovsManualChart = [];
    let manualResolvedTickets = 0;
    let koresolvedTickets = 0;
    let isKovsManualData = false;
    tickets.forEach(ticket => {
      if (
        ticket.state_value.toString().toLowerCase() ===
          this.ticketingService.getStatusConstantValue('Resolved', 'incident').itsm_value.toLowerCase() &&
        ticket.resolve_type
          .toString()
          .replace(' ', '')
          .toLowerCase() === 'knowledgeobject'
      ) {
        koresolvedTickets = koresolvedTickets + 1;
      } else if (
        ticket.state_value.toString().toLowerCase() ===
          this.ticketingService.getStatusConstantValue('Resolved', 'incident').itsm_value.toLowerCase() &&
        ticket.resolve_type.toString().toLowerCase() === 'manual'
      ) {
        manualResolvedTickets = manualResolvedTickets + 1;
      }
    });
    const manualChart = new ChartList();
    manualChart.name = 'Tickets resolved manually';
    manualChart.y = manualResolvedTickets;
    kovsManualChart.push(manualChart);
    const koChart = new ChartList();
    koChart.name = 'Tickets resolved by KO';
    koChart.y = koresolvedTickets;
    kovsManualChart.push(koChart);

    kovsManualChart.forEach(data => {
      if (data.y > 0) {
        isKovsManualData = true;
      }
    });
    output.chartData = kovsManualChart;
    output.isAvailable = isKovsManualData;
    return output;
  }

  getDaysArray(date: Date) {
    const count = date.getDay();
    if (count === 0) {
      return ['Sunday', 'Saturday', 'Friday', 'Thursday', 'Wednesday', 'Tuesday', 'Monday'];
    } else if (count === 1) {
      return ['Monday', 'Sunday', 'Saturday', 'Friday', 'Thursday', 'Wednesday', 'Tuesday'];
    } else if (count === 2) {
      return ['Tuesday', 'Monday', 'Sunday', 'Saturday', 'Friday', 'Thursday', 'Wednesday'];
    } else if (count === 3) {
      return ['Wednesday', 'Tuesday', 'Monday', 'Sunday', 'Saturday', 'Friday', 'Thursday'];
    } else if (count === 4) {
      return ['Thursday', 'Wednesday', 'Tuesday', 'Monday', 'Sunday', 'Saturday', 'Friday'];
    } else if (count === 5) {
      return ['Friday', 'Thursday', 'Wednesday', 'Tuesday', 'Monday', 'Sunday', 'Saturday'];
    } else if (count === 6) {
      return ['Saturday', 'Friday', 'Thursday', 'Wednesday', 'Tuesday', 'Monday', 'Sunday'];
    }
  }

  ticketsResolvedbyKO(tickets: any) {
    const output: any = {};
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const mostUsedCharts = [0, 0, 0, 0, 0, 0, 0];
    const date = new Date();
    const weekDays = this.getDaysArray(date);
    tickets.forEach(ticket => {
      if (
        ticket.resolve_type
          .toString()
          .replace(' ', '')
          .toLowerCase() === 'knowledgeobject'
      ) {
        const updatedDate = ticket.sys_updated_on;
        const result = updatedDate.split(' ');
        const newdate = result[0].trim().split('-');
        const time = result[1].trim().split(':');
        const endDate = new Date();
        const purchaseDate = new Date(
          parseInt(newdate[0], 10),
          parseInt(newdate[1], 10) - 1,
          parseInt(newdate[2], 10),
          parseInt(time[0], 10),
          parseInt(time[1], 10),
          parseInt(time[2], 10)
        );
        const diffMs = Math.abs(endDate.getTime() - purchaseDate.getTime()); // milliseconds
        const diffDays = Math.floor(diffMs / 86400000); // days
        const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        if (diffDays === 0) {
          mostUsedCharts[0] = mostUsedCharts[0] + 1;
        } else if (diffDays === 1) {
          mostUsedCharts[1] = mostUsedCharts[1] + 1;
        } else if (diffDays === 2) {
          mostUsedCharts[2] = mostUsedCharts[2] + 1;
        } else if (diffDays === 3) {
          mostUsedCharts[3] = mostUsedCharts[3] + 1;
        } else if (diffDays === 4) {
          mostUsedCharts[4] = mostUsedCharts[4] + 1;
        } else if (diffDays === 5) {
          mostUsedCharts[5] = mostUsedCharts[5] + 1;
        } else if (diffDays === 6) {
          mostUsedCharts[6] = mostUsedCharts[6] + 1;
        }
      }
    });
    const columnChart = new ColumnChartModel();
    columnChart.data = mostUsedCharts;
    columnChart.type = undefined;
    const mostUsedKOBarChart = [];
    let mostUsedKOBarData = false;
    mostUsedKOBarChart.push(columnChart);
    mostUsedKOBarChart.forEach(data => {
      if (data > 0) {
        mostUsedKOBarData = true;
      }
    });
    output.chartData = mostUsedKOBarChart;
    output.isAvailable = mostUsedKOBarData;
    return output;
  }

  getResolvedTicketCount(tickets: any) {
    const output: any = {};
    if (!tickets) {
      output.primaryTickets = [];
      output.secTicketsCount = [];
      output.thirdTicketCount = [];
      return output;
    }

    const today = new Date();
    const day = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
    const month = today.getMonth() > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
    const yesterdayDay = today.getDate() > 9 ? today.getDate() - 1 : '0' + (today.getDate() - 1);
    const yesterdayDate = today.getFullYear() + '-' + month + '-' + yesterdayDay;
    const currentDate = today.getFullYear() + '-' + month + '-' + day;

    let primaryTickets = 0;
    let secTicketsCount = 0;
    let thirdTicketCount = 0;
    tickets.forEach(ticket => {
      if (
        ticket.state_value.toString().toLowerCase() ===
        this.ticketingService.getStatusConstantValue('Resolved', 'incident').itsm_value.toLowerCase()
      ) {
        const updatedDate = ticket.sys_updated_on;
        const result = updatedDate.split(' ');
        const date = result[0].trim().split('-');
        const time = result[1].trim().split(':');
        const endDate = new Date();
        const purchaseDate = new Date(
          parseInt(date[0], 10),
          parseInt(date[1], 10) - 1,
          parseInt(date[2], 10),
          parseInt(time[0], 10),
          parseInt(time[1], 10),
          parseInt(time[2], 10)
        );
        const diffMs = Math.abs(endDate.getTime() - purchaseDate.getTime()); // milliseconds
        const diffDays = Math.floor(diffMs / 86400000); // days
        const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        if (result[0] === currentDate) {
          primaryTickets = primaryTickets + 1;
        } else if (result[0] === yesterdayDate) {
          secTicketsCount = secTicketsCount + 1;
        }
        if (diffDays < 9) {
          thirdTicketCount = thirdTicketCount + 1;
        }
      }
    });
    output.primaryTickets = primaryTickets;
    output.secTicketsCount = secTicketsCount;
    output.thirdTicketCount = thirdTicketCount;
    return output;
  }

  parseDataforCategoryChart(tickets: any) {
    const output: any = {};
    let isCategoryChart = false;
    const chartCategoryList = [];
    if (tickets) {
      tickets.forEach(element => {
        let isElementMatch: boolean;
        if (element.sys_class_name) {
          chartCategoryList.forEach(chartElement => {
            if (element.sys_class_name === chartElement.name) {
              isElementMatch = true;
              chartElement.y = chartElement.y + 1;
            }
          });
          if (!isElementMatch) {
            const chart = new ChartList();
            chart.name = element.sys_class_name;
            chart.y = 1;
            chartCategoryList.push(chart);
          }
        }
      });

      if (chartCategoryList.length > 0) {
        isCategoryChart = true;
      }
    }
    output.chartData = chartCategoryList;
    output.isAvailable = isCategoryChart;
    return output;
  }

  // mostUsedKOs(tickets: any) {
  //   const output: any = {};
  //   let isAvailable = false;
  //   const chartMostUsedKOs = [];
  //   if (tickets) {
  //     tickets.forEach(element => {
  //       let isElementMatch: boolean;
  //       if (
  //         element.ko_id &&
  //         element.state_value &&
  //         element.resolve_type &&
  //         element.resolve_type
  //           .toString()
  //           .replace(' ', '')
  //           .toLowerCase() === 'knowledgeobject' &&
  //         (element.state_value.toLowerCase() ===
  //           this.ticketingService.getStatusConstantValue('Resolved', 'incident').itsm_value.toLowerCase() ||
  //           element.state_value.toLowerCase() ===
  //             this.ticketingService.getStatusConstantValue('Closed', 'incident').itsm_value.toLowerCase() ||
  //           element.state_value.toLowerCase() ===
  //             this.ticketingService.getStatusConstantValue('Cancelled', 'incident').itsm_value.toLowerCase())
  //       ) {
  //         chartMostUsedKOs.forEach(chartElement => {
  //           if (element.ko_id === chartElement.name) {
  //             isElementMatch = true;
  //             chartElement.y = chartElement.y + 1;
  //           }
  //         });
  //         if (!isElementMatch) {
  //           const chart = new ChartList();
  //           chart.name = element.ko_id;
  //           chart.y = 1;
  //           chartMostUsedKOs.push(chart);
  //         }
  //       }
  //     });
  //     if (chartMostUsedKOs.length > 0) {
  //       isAvailable = true;
  //     }
  //     output.chartData = chartMostUsedKOs;
  //     output.isAvailable = isAvailable;
  //     return output;
  //   }
  // }

  getMostUsedKoChart(fromDate, toDate) {
    return this.apiService.get(ticketChartAPIConfig.getMostUsedKoChart, {}, [
      { param: 'fromDate', replaceWith: fromDate },
      { param: 'toDate', replaceWith: toDate }
    ]);
  }
  getKOUsageByASGChart(fromDate, toDate) {
    return this.apiService.get(ticketChartAPIConfig.getKOUsageByASGChart, {}, [
      { param: 'fromDate', replaceWith: fromDate },
      { param: 'toDate', replaceWith: toDate }
    ]);
  }
  getTicketResolvedByKOWeekly(fromDate, toDate) {
    return this.apiService.get(ticketChartAPIConfig.getTicketResolvedByKOWeekly, {}, [
      { param: 'fromDate', replaceWith: fromDate },
      { param: 'toDate', replaceWith: toDate }
    ]);
  }
  getTicketResolvedByKODaily(fromDate, toDate) {
    return this.apiService.get(ticketChartAPIConfig.getTicketResolvedByKODaily, {}, [
      { param: 'fromDate', replaceWith: fromDate },
      { param: 'toDate', replaceWith: toDate }
    ]);
  }
  mostUsedBots(tickets: any) {
    const output: any = {};
    let isAvailable = false;
    const chartMostUsedBots = [];
    if (tickets) {
      tickets.forEach(element => {
        let isElementMatch: boolean;
        if (
          element.proposed_solution &&
          element.resolve_type &&
          element.resolve_type
            .toString()
            .replace(' ', '')
            .toLowerCase() === 'automation' &&
          (element.state_value.toString().toLowerCase() ===
            this.ticketingService.getStatusConstantValue('Resolved', 'incident').itsm_value.toLowerCase() ||
            element.state_value.toString().toLowerCase() ===
              this.ticketingService.getStatusConstantValue('Closed', 'incident').itsm_value.toLowerCase() ||
            element.state_value.toString().toLowerCase() ===
              this.ticketingService.getStatusConstantValue('Cancelled', 'incident').itsm_value.toLowerCase())
        ) {
          chartMostUsedBots.forEach(chartElement => {
            if (element.proposed_solution === chartElement.name) {
              isElementMatch = true;
              chartElement.y = chartElement.y + 1;
            }
          });
          if (!isElementMatch) {
            const chart = new ChartList();
            chart.name = element.proposed_solution;
            chart.y = 1;
            chartMostUsedBots.push(chart);
          }
        }
      });
      if (chartMostUsedBots.length > 0) {
        isAvailable = true;
      }
      output.chartData = chartMostUsedBots;
      output.isAvailable = isAvailable;
      return output;
    }
  }

  // parseDataforAutomation(tickets: any) {
  //   // const sankeyChart = [];
  //   const output: any = {};
  //   let isAvailable = false;
  //   const sankeyChart = [];
  //   if (tickets) {
  //     tickets.forEach(ticket => {
  //       let isElementMatch: boolean;
  //       sankeyChart.forEach((row: SankeyModel) => {
  //         if (row.from === ticket.assignment_group_value && row.to === ticket.resolve_type) {
  //           isElementMatch = true;
  //           row.weight = row.weight + 1;
  //         }
  //       });
  //       if (!isElementMatch) {
  //         if (ticket.assignment_group_value && ticket.resolve_type) {
  //           const chart = new SankeyModel();
  //           chart.from = ticket.assignment_group_value ? ticket.assignment_group_value : 'No data';
  //           chart.to = ticket.resolve_type ? ticket.resolve_type : 'No data';
  //           chart.weight = 1;
  //           sankeyChart.push(chart);
  //         }
  //       }
  //     });
  //     if (sankeyChart.length > 0) {
  //       isAvailable = true;
  //     }
  //     output.chartData = sankeyChart;
  //     output.isAvailable = isAvailable;
  //     return output;
  //   }
  // }

  getAutomationUsageChart(body: any) {
    return this.apiService.post(ticketChartAPIConfig.getAutomationUsageChart, body);
  }

  // parseDataforChart(tickets: any) {
  //   const output: any = {};
  //   let isAvailable = false;
  //   const chartList = [];
  //   if (tickets) {
  //     tickets.forEach(element => {
  //       let isElementMatch: boolean;
  //       if (element.application && element.state_value) {
  //         chartList.forEach(chartElement => {
  //           if (element.application === chartElement.from && element.state_value === chartElement.to) {
  //             isElementMatch = true;
  //             chartElement.weight = chartElement.weight + 1;
  //           }
  //         });
  //         if (!isElementMatch) {
  //           const chart = new SankeyModel();
  //           chart.from = element.application ? element.application : 'No data';
  //           chart.to = element.state_value ? element.state_value : 'No data';
  //           chart.weight = 1;
  //           chartList.push(chart);
  //         }
  //       }
  //     });
  //     if (chartList.length > 0) {
  //       isAvailable = true;
  //     }
  //   }
  //   output.chartData = chartList;
  //   output.isAvailable = isAvailable;
  //   return output;
  // }

  getTicketsPerAppChart(body: any) {
    return this.apiService.post(ticketChartAPIConfig.getTicketsPerAppChart, body);
  }

  // parseDataforStatusChart(tickets: any) {
  //   const chartStatusList = [];
  //   const output: any = {};
  //   let isAvailable = false;
  //   if (tickets) {
  //     tickets.forEach(element => {
  //       let isElementMatch: boolean;
  //       if (element.state_value && element.assignment_group_value) {
  //         chartStatusList.forEach(chartElement => {
  //           if (element.state_value === chartElement.to && element.assignment_group_value === chartElement.from) {
  //             isElementMatch = true;
  //             chartElement.weight = chartElement.weight + 1;
  //           }
  //         });
  //         if (!isElementMatch) {
  //           const chart = new SankeyModel();
  //           chart.to = element.state_value ? element.state_value : 'No data';
  //           chart.from = element.assignment_group_value ? element.assignment_group_value : 'No data';
  //           chart.weight = 1;
  //           chartStatusList.push(chart);
  //         }
  //       }
  //     });
  //     if (chartStatusList.length > 0) {
  //       isAvailable = true;
  //     }
  //   }
  //   output.chartData = chartStatusList;
  //   output.isAvailable = isAvailable;
  //   return output;
  // }

  getStatusDistributionChart(body: any) {
    return this.apiService.post(ticketChartAPIConfig.getStatusDistributionChart, body);
  }

  // parseDataforPriorityChart(tickets: any) {
  //   const chartPriorityList = [];
  //   const output: any = {};
  //   let isAvailable = false;
  //   if (tickets) {
  //     tickets.forEach(element => {
  //       let isElementMatch: boolean;
  //       if (element.priority_value) {
  //         chartPriorityList.forEach(chartElement => {
  //           // if (element.priority_value.substr(4) === chartElement.name) {
  //           if (element.priority_value === chartElement.name) {
  //             isElementMatch = true;
  //             chartElement.y = chartElement.y + 1;
  //           }
  //         });
  //         if (!isElementMatch) {
  //           const chart = new ChartList();
  //           // chart.name = element.priority_value.substr(4);
  //           chart.name = element.priority_value;
  //           chart.y = 1;
  //           chartPriorityList.push(chart);
  //         }
  //       }
  //     });
  //     if (chartPriorityList.length > 0) {
  //       isAvailable = true;
  //     }
  //   }
  //   output.chartData = chartPriorityList;
  //   output.isAvailable = isAvailable;
  //   return output;
  // }

  getTicketsPriorityChart(body: any) {
    return this.apiService.post(ticketChartAPIConfig.getTicketsPriorityChart, body);
  }

  // parseDataforWorkitemChart(tickets: any) {
  //   const chartworkitemList = [];
  //   const output: any = {};
  //   let isAvailable = false;
  //   if (tickets) {
  //     tickets.forEach(element => {
  //       let isElementMatch: boolean;
  //       if (element.assigned_to_value && element.assignment_group_value) {
  //         chartworkitemList.forEach(chartElement => {
  //           if (element.assigned_to_value === chartElement.from && element.assignment_group_value === chartElement.to) {
  //             isElementMatch = true;
  //             chartElement.weight = chartElement.weight + 1;
  //           }
  //         });
  //         if (!isElementMatch) {
  //           const chart = new SankeyModel();
  //           chart.from = element.assigned_to_value ? element.assigned_to_value : 'No data';
  //           chart.to = element.assignment_group_value ? element.assignment_group_value : 'No data';
  //           chart.weight = 1;
  //           chartworkitemList.push(chart);
  //         }
  //       }
  //     });
  //     if (chartworkitemList.length > 0) {
  //       isAvailable = true;
  //     }
  //   }
  //   output.chartData = chartworkitemList;
  //   output.isAvailable = isAvailable;
  //   return output;
  // }

  getWorkitemDistributionChart(body: any) {
    return this.apiService.post(ticketChartAPIConfig.getWorkitemDistributionChart, body);
  }

  getTicketsResolvedChart(body: any) {
    return this.apiService.post(ticketChartAPIConfig.getTicketsResolvedChart, body);
  }

  parseDataforReasonforHoldChart(tickets: any) {
    const chartReasonHoldList = [];
    const output: any = {};
    let isAvailable = false;
    if (tickets) {
      tickets.forEach(element => {
        let isElementMatch: boolean;
        if (element.pending_reason && element.state_value.toString().toLowerCase() === 'on hold') {
          chartReasonHoldList.forEach(chartElement => {
            if (element.pending_reason === chartElement.name) {
              isElementMatch = true;
              chartElement.y = chartElement.y + 1;
            }
          });
          if (!isElementMatch) {
            const chart = new ChartList();
            chart.name = element.pending_reason;
            chart.y = 1;
            chartReasonHoldList.push(chart);
          }
        }
      });
    }
    if (chartReasonHoldList.length > 0) {
      isAvailable = true;
    }
    output.chartData = chartReasonHoldList;
    output.isAvailable = isAvailable;
    return output;
  }

  // parseDataforExpiryChart(tickets: any) {
  //   let isExpiryChartAvailable = false;
  //   const output: any = {};
  //   let chartDataItems;
  //   const chartExpiryList = this.getChartExpiryListOnTime();
  //   if (tickets) {
  //     tickets.forEach(element => {
  //       if (
  //         element.sla &&
  //         element.state_value &&
  //         element.state_value.toLowerCase() !==
  //           this.ticketingService.getStatusConstantValue('Resolved', 'incident').itsm_value.toLowerCase() &&
  //         element.state_value.toLowerCase() !==
  //           this.ticketingService.getStatusConstantValue('Closed', 'incident').itsm_value.toLowerCase() &&
  //         element.state_value.toLowerCase() !==
  //           this.ticketingService.getStatusConstantValue('Cancelled', 'incident').itsm_value.toLowerCase()
  //       ) {
  //         const slaDate: any = new Date(element.sla);
  //         const currentDate: any = new Date();
  //         const milisec = slaDate - currentDate;
  //         const getTime = this.getDays(milisec);
  //         const daysArr = getTime.split(':');
  //         const diffHrs = +daysArr[1];
  //         const diffDays = +daysArr[0];
  //         chartExpiryList.forEach(listElement => {
  //           // if (diffDays === 0 && diffHrs < 6) {
  //           //   if (listElement.name === 'Expiring next 6 hrs') {
  //           //     listElement.y = listElement.y + 1;
  //           //   }
  //           // } else
  //           if (milisec < 0) {
  //             if (listElement.name === this.translateService.instant('app.lang.ticketing.chartData.expired')) {
  //               listElement.y = listElement.y + 1;
  //             }
  //           } else if (diffDays === 0 && diffHrs <= 1) {
  //             if (listElement.name === this.translateService.instant('app.lang.ticketing.chartData.expiringOneDay')) {
  //               listElement.y = listElement.y + 1;
  //             }
  //           } else if (diffDays === 0 && diffHrs <= 4) {
  //             if (listElement.name === this.translateService.instant('app.lang.ticketing.chartData.foutHour')) {
  //               listElement.y = listElement.y + 1;
  //             }
  //           } else if (diffDays === 0 && diffHrs <= 8) {
  //             if (listElement.name === this.translateService.instant('app.lang.ticketing.chartData.eightHour')) {
  //               listElement.y = listElement.y + 1;
  //             }
  //           } else if (diffDays === 0 && diffHrs <= 24) {
  //             if (listElement.name === this.translateService.instant('app.lang.ticketing.chartData.oneDay')) {
  //               listElement.y = listElement.y + 1;
  //             }
  //           } else if (diffDays > 0) {
  //             if (listElement.name === this.translateService.instant('app.lang.ticketing.chartData.expiringOneDay')) {
  //               listElement.y = listElement.y + 1;
  //             }
  //           }
  //         });
  //       }
  //       chartDataItems = tickets.length;
  //     });

  //     chartExpiryList.forEach(dataItem => {
  //       if (dataItem.y > 0) {
  //         isExpiryChartAvailable = true;
  //       }
  //     });
  //   }
  //   output.chartData = chartExpiryList;
  //   output.chartDataItems = chartDataItems;
  //   output.isAvailable = isExpiryChartAvailable;
  //   return output;
  // }

  getExpiringTicketsChart(body: any) {
    return this.apiService.post(ticketChartAPIConfig.getExpiringTicketsChart, body);
  }

  // getExpiringTicketsChart(body: any) {
  //   const assignmentGrpIds = [];
  //   this.assignmentGroups.filter(i => {
  //     assignmentGrpIds.push(i.assignment_group_id);
  //   });
  //   const userSysIds = [];
  //   userSysIds.push(this.loggedInUserSysId);

  //   if (!this.checkUserOptionValue() || this.checkUserOptionValue() === 'myTickets') {
  //     body.sys_id = userSysIds;
  //   } else if (this.checkUserOptionValue() === 'assignmentGroupTickets' && this.assignmentGroups) {
  //     body.sys_id = assignmentGrpIds;
  //   } else if (this.checkUserOptionValue() === 'automationApproval' && this.assignmentGroups) {
  //     body.sys_id = assignmentGrpIds;
  //   } else if (this.checkUserOptionValue() === 'myTasks' && this.assignmentGroups) {
  //     body.sys_id = userSysIds;
  //   } else if (this.checkUserOptionValue() === 'assignmentGroupTasks' && this.assignmentGroups) {
  //     body.sys_id = assignmentGrpIds;
  //   } else {
  //     console.error('Data inconsistency issue');
  //   }
  //   return this.apiService.post(ticketChartAPIConfig.getExpiringTicketsChart, body);
  // }

  getDays(ms: number) {
    const days = Math.floor(ms / (24 * 60 * 60 * 1000));
    const daysms = ms % (24 * 60 * 60 * 1000);
    const hours = Math.floor(daysms / (60 * 60 * 1000));
    const hoursms = ms % (60 * 60 * 1000);
    const minutes = Math.floor(hoursms / (60 * 1000));
    const minutesms = ms % (60 * 1000);
    const sec = Math.floor(minutesms / 1000);
    return days + ':' + hours + ':' + minutes + ':' + sec;
  }

  //   parseDataforHoldtimeChart(tickets: any) {
  //     this.isHoldDataAvailable = false;
  //     if (tickets) {
  //       const chartHoldTimeList = this.getChartHoldtimeList();

  //       tickets.forEach(element => {
  //         if (element.sys_updated_on && element.state_value.toString().toLowerCase() === 'on hold') {
  //           const result = element.sys_updated_on.split(' ');
  //           const date = result[0].trim().split('-');
  //           const time = result[1].trim().split(':');
  //           const endDate = new Date();
  //           const purchaseDate = new Date(
  //             parseInt(date[0], 10),
  //             parseInt(date[1], 10) - 1,
  //             parseInt(date[2], 10),
  //             parseInt(time[0], 10),
  //             parseInt(time[1], 10),
  //             parseInt(time[2], 10)
  //           );
  //           const diffMs = Math.abs(endDate.getTime() - purchaseDate.getTime()); // milliseconds
  //           const diffDays = Math.floor(diffMs / 86400000); // days
  //           const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours

  //           chartHoldTimeList.forEach(listElement => {
  //             // if (diffDays === 0 && diffHrs < 6) {
  //             //   if (listElement.name === 'Expiring next 6 hrs') {
  //             //     listElement.y = listElement.y + 1;
  //             //   }
  //             // } else
  //             if (diffDays < 1) {
  //               if (listElement.name === '0-1 days') {
  //                 listElement.y = listElement.y + 1;
  //               }
  //             } else if (diffDays < 2) {
  //               if (listElement.name === '2 days') {
  //                 listElement.y = listElement.y + 1;
  //               }
  //             } else if (diffDays < 3) {
  //               if (listElement.name === '3 days') {
  //                 listElement.y = listElement.y + 1;
  //               }
  //             } else if (diffDays < 4) {
  //               if (listElement.name === '4 days') {
  //                 listElement.y = listElement.y + 1;
  //               }
  //             } else {
  //               if (listElement.name === '5+ days') {
  //                 listElement.y = listElement.y + 1;
  //               }
  //             }
  //           });
  //         }
  //       });
  //       this.chartHoldTimeList = chartHoldTimeList;
  //     }
  //     this.chartHoldTimeList.forEach(dataItem => {
  //       if (dataItem.y > 0) {
  //         this.isHoldDataAvailable = true;
  //       }
  //     });
  //   }

  getChartExpiryList() {
    const chartList: ChartList[] = [];
    let chartItem = new ChartList();
    chartItem.name = this.translateService.instant('app.lang.ticketing.chartData.expired');
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    chartItem.name = this.translateService.instant('app.lang.ticketing.chartData.item1');
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    chartItem.name = this.translateService.instant('app.lang.ticketing.chartData.item2');
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    chartItem.name = this.translateService.instant('app.lang.ticketing.chartData.item3');
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    chartItem.name = this.translateService.instant('app.lang.ticketing.chartData.item4');
    chartItem.y = 0;
    chartList.push(chartItem);
    return chartList;
  }

  getChartExpiryListOnTime() {
    const chartList: ChartList[] = [];
    let chartItem = new ChartList();
    const expired = this.translateService.instant('app.lang.ticketing.chartData.expired');
    chartItem.name = expired;
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    const expiringOneDay = this.translateService.instant('app.lang.ticketing.chartData.expiringOneDay');
    chartItem.name = expiringOneDay;
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    const withinHour = this.translateService.instant('app.lang.ticketing.chartData.withinHour');
    chartItem.name = withinHour;
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    const foutHour = this.translateService.instant('app.lang.ticketing.chartData.foutHour');
    chartItem.name = foutHour;
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    const eightHour = this.translateService.instant('app.lang.ticketing.chartData.eightHour');
    chartItem.name = eightHour;
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    const oneDay = this.translateService.instant('app.lang.ticketing.chartData.oneDay');
    chartItem.name = oneDay;
    chartItem.y = 0;
    chartList.push(chartItem);
    return chartList;
  }

  getChartHoldtimeList() {
    const chartList: ChartList[] = [];
    let chartItem = new ChartList();
    chartItem.name = '0-1 days';
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    chartItem.name = '2 days';
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    chartItem.name = '3 days';
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    chartItem.name = '4 days';
    chartItem.y = 0;
    chartList.push(chartItem);

    chartItem = new ChartList();
    chartItem.name = '5+ days';
    chartItem.y = 0;
    chartList.push(chartItem);
    return chartList;
  }

  //   parseDataforExpiry(tickets: any) {
  //     if (tickets) {
  //       this.expiredTickets = [];
  //       this.ticketsExpiringToday = [];
  //       this.expiringFuture = [];
  //       tickets.forEach(element => {
  //         if (element.sla_due) {
  //           const result = element.sla_due.split(' ');
  //           const date = result[0].trim().split('-');
  //           const time = result[1].trim().split(':');
  //           const endDate = new Date();
  //           const purchaseDate = new Date(
  //             parseInt(date[0], 10),
  //             parseInt(date[1], 10) - 1,
  //             parseInt(date[2], 10),
  //             parseInt(time[0], 10),
  //             parseInt(time[1], 10),
  //             parseInt(time[2], 10)
  //           );
  //           const diffMs = Math.abs(endDate.getTime() - purchaseDate.getTime()); // milliseconds
  //           const diffDays = Math.floor(diffMs / 86400000); // days
  //           const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
  //           if (diffDays <= 0 && diffHrs <= 0) {
  //             let isElementMatch: boolean;
  //             if (element.application) {
  //               this.expiredTickets.forEach(chartElement => {
  //                 if (element.application === chartElement.name) {
  //                   isElementMatch = true;
  //                   chartElement.y = chartElement.y + 1;
  //                 }
  //               });
  //               if (!isElementMatch) {
  //                 const chart = new ChartList();
  //                 chart.name = element.application;
  //                 chart.y = 1;
  //                 this.expiredTickets.push(chart);
  //               }
  //             }
  //           }
  //           // } else if (diffDays < 1 && diffHrs < 24) {
  //           //   let isElementMatch: boolean;
  //           //   if (element.application) {
  //           //     this.ticketsExpiringToday.forEach(chartElement => {
  //           //       if (element.application === chartElement.name) {
  //           //         isElementMatch = true;
  //           //         chartElement.y = chartElement.y + 1;
  //           //       }
  //           //     });
  //           //     if (!isElementMatch) {
  //           //       const chart = new ChartList();
  //           //       chart.name = element.application;
  //           //       chart.y = 1;
  //           //       this.ticketsExpiringToday.push(chart);
  //           //     }
  //           //   }
  //           // }
  //           else if (diffDays < 3) {
  //             let isElementMatch: boolean;
  //             if (element.application) {
  //               this.expiringFuture.forEach(chartElement => {
  //                 if (element.application === chartElement.name) {
  //                   isElementMatch = true;
  //                   chartElement.y = chartElement.y + 1;
  //                 }
  //               });
  //               if (!isElementMatch) {
  //                 const chart = new ChartList();
  //                 chart.name = element.application;
  //                 chart.y = 1;
  //                 this.expiringFuture.push(chart);
  //               }
  //             }
  //           }
  //         }
  //       });
  //       this.expiredTicketsTotal = this.expiredTickets.length;
  //       // this.expiringTodayTicketsTotal = this.ticketsExpiringToday.length;
  //       this.expiringFutureTicketsTotal = this.expiringFuture.length;
  //     }
  //   }

  checkUserOptionValue() {
    return this.getUserdata().selectedOption;
  }

  getChartBody(selStatus: any, dateRange: any, requestedPage: any, isHome: any, addparams?: any) {
    const body: any = {};
    const assignmentGrpIds = [];
    body.sys_id = [];
    body.states = selStatus;
    body.fromdate = dateRange.fromDate;
    body.todate = dateRange.toDate;
    body.requestPage = '';

    const userSysIds = [];
    userSysIds.push(this.getUserdata().userSysId);

    this.assignmentGroups = this.getUserdata().groupSysIdFilter;
    this.assignmentGroups.filter(i => {
      assignmentGrpIds.push(i.sys_id);
    });

    if (isHome || addparams) {
      body.sys_id = assignmentGrpIds;
      body.requestPage = 'assignmentGroupTickets';
    } else if (!this.checkUserOptionValue() || this.checkUserOptionValue() === 'myTickets') {
      body.sys_id = userSysIds;
      body.requestPage = requestedPage;
    } else if (this.checkUserOptionValue() === 'assignmentGroupTickets' && this.assignmentGroups) {
      body.sys_id = assignmentGrpIds;
      body.requestPage = requestedPage;
    } else if (this.checkUserOptionValue() === 'myApprovals' && this.assignmentGroups) {
      body.sys_id = assignmentGrpIds;
    } else {
      console.error('Data inconsistency issue');
    }

    return body;
    //////////////////////////////////////////////////////////////
  }

  getUserdata() {
    const userId = this.authService.getAuthenticatedUserId();
    let userData: any = {};
    userData = this.dataStore.getData(true, userId);
    return userData;
  }
}
